// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"job-experience-row-module--card-header--3Ozp1","toggleChevron":"job-experience-row-module--toggle-chevron--36BLt"};